import React, { ReactNode } from "react"
import * as styles from './heading.module.css'

export default function Heading({type=1, children, light, weightNormal, mb, mbLarge, small, xSmall, large,}: {
    type?: number;
    children: ReactNode
    light?: boolean;
    weightNormal?: boolean;
    mb?: boolean;
    mbLarge?: boolean;
    small?: boolean;
    xSmall?: boolean;
    large?: boolean;
}) {
    return React.createElement(`h${type}`, {className: [
        styles.heading,
        type === 2 && styles.subHeading,
        type === 3 && styles.subSubHeading,
        light && styles.heading__light,
        weightNormal && styles.heading__weightNormal,
        mb && styles.mb,
        mbLarge && styles.mbLarge,
        small && styles.small,
        xSmall && styles.xSmall,
        large && styles.large,
    ].join(' ')}, children)
}